import maintenanceTypes from '@/store/dict/maintenance'
import { operateMaxShowLength } from '@/store/dict/config'

export default function () {
/** **************selectColumns***************************************************************** */
  const searchBoxColumns = [
    {
      type: 'select',
      label: '项目名称(ID)',
      key: 'id',
      source: [],
      sourceKey: { label: 'name', value: 'id' },
      options: {
        clearable: true,
        filterable: true,
        remote: true,
        remoteMthod: this.getProjectNames,
      },
    },
    {
      type: 'select',
      label: '项目类型',
      key: 'itemType',
      source: maintenanceTypes.projectTypesSource,
      options: {
        clearable: true,
      },
    },

    {
      type: 'select',
      label: '维保类型',
      key: 'maintenanceType',
      source: [{ label: '保养', value: 0 }, { label: '维修', value: 1 }],
      options: {
        clearable: true,
      },
    },
    {
      type: 'select',
      label: '适用城市',
      key: 'cityCode',
      source: [],
      sourceKey: { label: 'name', value: 'id' },
      options: {
        clearable: true,
      },
    },
    {
      type: 'select',
      label: '状态',
      key: 'state',
      source: [{ label: '无效', value: 0 }, { label: '有效', value: 1 }],
      options: {
        clearable: true,
      },
    },
    {
      type: 'input',
      label: '合作关系ID',
      key: 'collaborationId',
      options: {
        clearable: true,
      },
    },
    {
      type: 'select',
      label: '合作服务商名称(ID)',
      labbelWidth: '200px',
      key: 'serviceId',
      source: [],
      sourceKey: { label: 'name', value: 'id' },
      options: {
        clearable: true,
        remote: true,
        remoteMthod: this.getCompanyProviderName,
        change_s: (e) => {
          if (e === '' || e === null) {
            this.getCompanyProviderName()
          }
        },
      },
    },
  ]

  /** ****************************************************************tableColumns********************************************************************************************** */
  const tableColumns = [
    {
      name: 'collaborationId',
      align: 'center',
      columnProps: {
        label: '合作关系ID',
        prop: 'collaborationId',
        minWidth: 120,
      },
      render: ({ row }) => {
        const btns = []
        btns.push(
          this.$createElement('el-button', {
            props: {
              type: 'text',
            },
            on: {
              click: () => {
                // 集团→采购→服务商管理→维保入驻审核，搜索指定ID
                this.openCollaborationPage(row)
              },
            },
          }, row.collaborationId),
        )
        return btns
      },
    },
    {
      name: 'serviceId',
      align: 'center',
      columnProps: {
        label: '合作服务商ID',
        prop: 'serviceId',
        minWidth: 120,
      },
      render: ({ row }) => {
        const btns = []
        btns.push(
          this.$createElement('el-button', {
            props: {
              type: 'text',
            },
            on: {
              click: () => {
                // 集团→采购→服务商管理→维保入驻审核，搜索指定ID
                this.openservicePage(row)
              },
            },
          }, row.serviceId),
        )
        return btns
      },
    },
    {
      name: 'serviceName',
      align: 'center',
      columnProps: {
        label: '合作服务商名称',
        prop: 'serviceName',
        minWidth: 120,
      },
    },
    {
      name: 'id',
      align: 'center',
      columnProps: {
        label: '项目ID',
        prop: 'id',
        minWidth: 120,
      },
      render: ({ row }) => {
        const btns = []
        btns.push(
          this.$createElement('el-button', {
            props: {
              type: 'text',
            },
            on: {
              click: () => {
                this.openDetailPage(row)
              },
            },
          }, row.id),
        )
        return btns
      },
    },
    {
      name: 'itemName',
      align: 'center',
      columnProps: {
        label: '项目名称',
        prop: 'itemName',
        minWidth: 120,
      },
    },
    {
      name: 'itemTypeName',
      align: 'center',
      columnProps: {
        label: '项目类型',
        prop: 'itemTypeName',
        minWidth: 120,
      },
    },
    {
      name: 'maintenanceTypeName',
      align: 'center',
      columnProps: {
        label: '维保类型',
        prop: 'maintenanceTypeName',
        minWidth: 120,
      },
    },
    {
      name: 'itemPrice',
      align: 'center',
      columnProps: {
        label: '方案价格(元)',
        prop: 'itemPrice',
        minWidth: 120,
      },
    },
    {
      name: 'agreePrice',
      align: 'center',
      columnProps: {
        label: '协议价格(元)',
        prop: 'agreePrice',
        minWidth: 120,
      },
    },
    {
      name: 'usableStoreNameList',
      align: 'center',
      columnProps: {
        label: '适用维修厂',
        prop: 'usableStoreNameList',
        minWidth: 120,
      },
    },
    {
      name: 'usableCityList',
      align: 'center',
      columnProps: {
        label: '适用城市',
        prop: 'usableCityList',
        minWidth: 120,
      },
    },
    {
      name: 'stateName',
      align: 'center',
      columnProps: {
        label: '状态',
        prop: 'stateName',
        minWidth: 120,
      },
    },
  ]

  this.$nextTick(() => {
    tableColumns.push(
      {
        name: 'operate',
        align: 'center',
        columnProps: {
          label: '操作',
          width: 240,
          fixed: 'right',
        },
        maxShowLength: operateMaxShowLength,
        render: ({ row }) => {
          const btns = []
          if (row.state) {
            btns.push(
              this.$createElement('el-button', {
                props: {
                  type: 'text',
                },
                on: {
                  click: () => {
                    this.bindPlanDialog(row)
                  },
                },
              }, '绑定租赁方案'),
            )

            btns.push(
              this.$createElement('el-button', {
                props: {
                  type: 'text',
                },
                on: {
                  click: () => {
                    this.bindOrderDialog(row)
                  },
                },
              }, '绑定租赁订单'),
            )
          }
          return btns
        },
      },
    )
  })

  /** ****************************************************************details->********************************************************************************************** */
  //
  const baseInfoColumns = [
    {
      key: 'subjectName',
      name: '项目名称',
    },
    {
      key: 'id',
      name: '项目ID',
    },
    {
      key: 'packageTypeText',
      name: '项目类型',
    },
    {
      key: 'maintenanceTypeText',
      name: '维保类型',
    },
    {
      key: 'gmtCreate',
      name: '创建时间',
    },
    {
      key: 'expireDay',
      name: '有效期',
    },
    {
      key: 'stateText',
      name: '状态',
    },
    {
      key: 'orderExpireDay',
      name: '订单有效期',
    },
    {
      key: 'itemRule',
      name: '套餐规则',
    },
  ]


  const abnormalData = new Map([
    ['scheme', {
      columns: [
        {
          name: 'rentPlanName',
          align: 'center',
          columnProps: {
            label: '租赁方案名称',
            prop: 'rentPlanName',
            minWidth: 120,
          },
        },
        {
          name: 'bindItemNames',
          align: 'center',
          columnProps: {
            label: '已绑定维保项目名称',
            prop: 'bindItemNames',
            minWidth: 120,
          },
        },
        {
          name: 'itemName',
          align: 'center',
          columnProps: {
            label: '新维保项目名称',
            prop: 'itemName',
            minWidth: 120,
          },
        },
      ],
      data: this.abnormalTableData || [],
    }],
    ['order', {
      columns: [
        {
          name: 'rentPlanName',
          align: 'center',
          columnProps: {
            label: '租赁订单名称',
            prop: 'rentPlanName',
            minWidth: 120,
          },
        },
        {
          name: 'driverName',
          align: 'center',
          columnProps: {
            label: '司机名称',
            prop: 'driverName',
            minWidth: 120,
          },
        }, {
          name: 'driverId',
          align: 'center',
          columnProps: {
            label: '司机ID',
            prop: 'driverId',
            minWidth: 120,
          },
        },
        {
          name: 'carModelName',
          align: 'center',
          columnProps: {
            label: '车型名称',
            prop: 'carModelName',
            minWidth: 120,
          },
        },
        {
          name: 'plantNo',
          align: 'center',
          columnProps: {
            label: '车牌号',
            prop: 'plantNo',
            minWidth: 100,
          },
        },
        {
          name: 'bindItemNames',
          align: 'center',
          columnProps: {
            label: '已绑定维保项目名称',
            prop: 'bindItemNames',
            minWidth: 120,
          },
        },
        {
          name: 'itemName',
          align: 'center',
          columnProps: {
            label: '新维保项目名称',
            prop: 'itemName',
            minWidth: 120,
          },
        },
      ],
      data: this.abnormalTableData || [],
    }],
  ])
  return {
    searchBoxColumns,
    tableColumns,
    baseInfoColumns,
    abnormalData,
  }
}
